<div class="quote-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="closeModal()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal">
          {{action}}
        </span>
        <span class="text-purple-manax text-capitalize title-modal">
          Presupuesto
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
  <form *ngIf="!loading" class="m-0" [formGroup]="form" (ngSubmit)="onSubmit()">

    <div class="row">
      <div class="col-12">

        <div class="row">
          <div class="col-12 document-content py-4" [ngClass]="{darken: readOnly}" (click)="setEditable()">

            <div class="row">

              <!-- Cliente -->
              <div class="col-12 col-md-5">
                <div class="row">
                  <div class="col-10">
                    <mat-form-field appearance="outline">
                      <mat-label>
                        Cliente
                        <span *ngIf="!(clientsTerm?.length || f['client']?.value)">(Escribe para buscar...)</span>
                      </mat-label>
                      <input matInput type="text" name="client" formControlName="client" [matAutocomplete]="autoClient"
                        [readonly]="readOnly">
                      <mat-autocomplete #autoClient="matAutocomplete" [displayWith]="displayClientsFn"
                        (optionSelected)="newClientSelected($event.option.value)" required>
                        <mat-option *ngFor="let client of $clients | async" [value]="client">
                          {{client.firstname}} {{client.lastname ? client.lastname : ''}}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                    <mat-error *ngIf="submitted && f['client']?.errors?.['required']">
                      Cliente Obligatorio
                    </mat-error>
                    <mat-error *ngIf="submitted && f['client']?.errors?.['notFound']">
                      Cliente NO Encontrado (Agregar Nuevo?)
                    </mat-error>
                  </div>
                  <div class="col-2 pt-2 pl-0">
                    <button type="button" class="btn btn-manax m-0 p-2" (click)="openNewClientModal()">
                      <i class="material-icons">add</i>
                    </button>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-7">
                <div class="row">

                  <!-- release date -->
                  <div class="col-12 col-md-3 ml-auto">
                    <mat-form-field appearance="outline" *ngIf="quote">
                      <mat-label>Emisión</mat-label>
                      <input matInput name="date" formControlName="date" type="date" class="d-flex" readonly>
                    </mat-form-field>
                  </div>

                  <!-- due date -->
                  <div class="col-12 col-md-3 pull-right">
                    <mat-form-field appearance="outline">
                      <mat-label>Vencimiento</mat-label>
                      <input matInput name="dueDate" formControlName="dueDate" type="date" class="d-flex">
                    </mat-form-field>
                    <mat-error *ngIf="submitted && f['dueDate']?.errors?.['required']">
                      Vencimiento es necesario
                    </mat-error>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <h5 class="m-0 pb-1 title-section"> Conceptos </h5>
                <app-detail-list [items]="quote.details || []" (listChange)="onListChange($event)"></app-detail-list>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>

            <div class="row">

              <!-- term and cond -->
              <div class="col-12 col-md-6">
                <mat-form-field appearance="outline">
                  <mat-label>Observaciones:</mat-label>
                  <textarea matInput formControlName="description" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="2" cdkAutosizeMaxRows="5" [errorStateMatcher]="customErrorStateMatcher">
                  </textarea>
                </mat-form-field>
              </div>


              <!-- notes -->
              <div class="col-12 col-md-6">
                <mat-form-field appearance="outline">
                  <mat-label>Términos y Condiciones:</mat-label>
                  <textarea matInput formControlName="termsAndConditions" cdkTextareaAutosize
                    [errorStateMatcher]="customErrorStateMatcher" #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2"
                    cdkAutosizeMaxRows="5">
                  </textarea>
                </mat-form-field>
              </div>
            </div>

          </div>
        </div>

        <div class="row">
          <div class="col-12 pb-0">
            <button mat-raised-button type="button" class="pull-left btn btn-outline" (click)="cancelSubmit()"
              *ngIf="!readOnly">
              Cancelar
            </button>
            <button mat-raised-button [disabled]="saving" type="submit" class="pull-right btn btn-manax"
              *ngIf="!readOnly">
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
              Guardar
            </button>

            <button mat-raised-button [disabled]="saving" type="button" (click)="scheduleTask()"
              *ngIf="readOnly && (quote.status != quoteStatuses.SCHEDULED)"
              class="m-0 mt-2 ml-2 px-3 pull-right btn btn-600 btn-manax">
              Programar Trabajo
            </button>

            <button mat-raised-button [disabled]="saving" type="button" (click)="setAcceptedQuote()"
              *ngIf="readOnly && (quote.status === quoteStatuses.QUOTED)"
              class="m-0 mt-2 ml-2 px-3 pull-right btn btn-600 btn-outline-manax">
              Aceptar Presupuesto
            </button>

            <button mat-raised-button [disabled]="saving" type="button" (click)="openQuote()" *ngIf="readOnly"
              class="m-0 mt-2 ml-2 px-3 pull-right btn btn-600 btn-outline-manax">
              Abrir PDF
            </button>

            <button mat-raised-button [disabled]="saving" type="button" (click)="cancelQuote()"
              *ngIf="readOnly && (quote.status != quoteStatuses.CANCELLED && quote.status != quoteStatuses.SCHEDULED)"
              class="pull-left btn btn-outline-danger">
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>


</div>